import { get, del, put, upload, post, uploadPut } from '../request';

export async function downloadFile(
  { publicService },
  authenticationToken,
  { s3ID },
) {
  const url = `${publicService}/public/filedownload/${s3ID}`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
}

export async function downloadFileInBrowser(
  { publicService },
  authenticationToken,
  { s3ID },
) {
  const url = `${publicService}/public/filedownload/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function fetchReports({ publicService }, authenticationToken) {
  const url = `${publicService}/public/config/reports`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMapConfiguration(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/publicmap`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateMapConfiguration(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/config/publicmap`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchReport(
  { publicService },
  authenticationToken,
  { reportID },
) {
  const url = `${publicService}/public/config/report/${reportID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteReport(
  { publicService },
  authenticationToken,
  { reportID },
) {
  const url = `${publicService}/public/config/report/${reportID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchReportCategories(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Public Website&name=Report Category`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchReportTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Public Website&name=Report Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxingUnits(
  { assessmentService },
  authenticationToken,
) {
  const url = `${assessmentService}/assessment/taxingunitssummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCounties({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/codes?type=Public Website&name=County`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMeetingLocations(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codefiles?type=Public%20Website&name=Public%20Meeting%20Location`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMeetingTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codefiles?type=Public%20Website&name=Public%20Meeting%20Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMeeting(
  { publicService },
  authenticationToken,
  { id },
) {
  const url = `${publicService}/public/meeting/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchLinks(
  { publicService },
  authenticationToken,
  { publicMeetingTypeCode },
) {
  const url = `${publicService}/public/meetinglinks?publicMeetingTypeCode=${publicMeetingTypeCode}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchLink(
  { publicService },
  authenticationToken,
  { linkID },
) {
  const url = `${publicService}/public/meetinglink/${linkID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteLink(
  { publicService },
  authenticationToken,
  { linkID },
) {
  const url = `${publicService}/public/meetinglink/${linkID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function insertLink(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/meetinglinks`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function updateLink(
  { publicService },
  authenticationToken,
  { linkID, payload, type },
) {
  const url = `${publicService}/public/meetinglink/${linkID}/${type}`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
}

export async function setMeetingOrder(
  { publicService },
  authenticationToken,
  { orderList },
) {
  const url = `${publicService}/public/meetings/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
}

export async function setLinkOrder(
  { publicService },
  authenticationToken,
  { orderList },
) {
  const url = `${publicService}/public/meetinglinks/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
}

export async function setMemberOrder(
  { publicService },
  authenticationToken,
  { orderList },
) {
  const url = `${publicService}/public/meetingboardmembers/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
}

export async function fetchMeetingInfo(
  { publicService },
  authenticationToken,
  { codeName },
) {
  const url = `${publicService}/public/meetinginfo/${codeName}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteMeetingInfo(
  { publicService },
  authenticationToken,
  { codeName },
) {
  const url = `${publicService}/public/meetinginfo/${codeName}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function insertMeetingInfo(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/meetinginfo`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchMeetings(
  { publicService },
  authenticationToken,
  { year, publicMeetingTypeCode },
) {
  const url = `${publicService}/public/meetings?${
    year !== 'All' ? `year=${year}&` : ''
  }publicMeetingTypeCode=${publicMeetingTypeCode}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMembers({ publicService }, authenticationToken) {
  const url = `${publicService}/public/meetingboardmembers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertMeeting(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/meetings`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function insertMember(
  { publicService },
  authenticationToken,
  { payload },
) {
  const url = `${publicService}/public/meetingboardmembers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteMeeting(
  { publicService },
  authenticationToken,
  { id },
) {
  const url = `${publicService}/public/meeting/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteMember(
  { publicService },
  authenticationToken,
  { id },
) {
  const url = `${publicService}/public/meetingboardmember/${id}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateMeetingFiles(
  { publicService },
  authenticationToken,
  { payload, id },
) {
  const url = `${publicService}/public/meeting/${id}/filesupdate`;
  const { body } = await uploadPut(authenticationToken, url, payload);
  return body;
}

export async function removeMeetingFiles(
  { publicService },
  authenticationToken,
  { payload, id },
) {
  const url = `${publicService}/public/meeting/${id}/filesremove`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateMeeting(
  { publicService },
  authenticationToken,
  { payload, id },
) {
  const url = `${publicService}/public/meeting/${id}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateMember(
  { publicService },
  authenticationToken,
  { payload, id },
) {
  const url = `${publicService}/public/meetingboardmember/${id}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateReport(
  { publicService },
  authenticationToken,
  { reportID, payload },
) {
  const url = `${publicService}/public/config/report/${reportID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertReport = async (
  { publicService },
  authenticationToken,
  { payload },
) => {
  const url = `${publicService}/public/config/reports`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export async function fetchForms({ publicService }, authenticationToken) {
  const url = `${publicService}/public/config/forms`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchForm(
  { publicService },
  authenticationToken,
  { formID },
) {
  const url = `${publicService}/public/config/form/${formID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteForm(
  { publicService },
  authenticationToken,
  { formID },
) {
  const url = `${publicService}/public/config/form/${formID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateForm(
  { publicService },
  authenticationToken,
  { formID, payload },
) {
  const url = `${publicService}/public/config/form/${formID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertForm = async (
  { publicService },
  authenticationToken,
  { payload },
) => {
  const url = `${publicService}/public/config/forms`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export async function fetchFormTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Public Website&name=Form Type`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAllNews({ publicService }, authenticationToken) {
  const url = `${publicService}/public/config/news`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchNews(
  { publicService },
  authenticationToken,
  { newsID },
) {
  const url = `${publicService}/public/config/news/${newsID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteNews(
  { publicService },
  authenticationToken,
  { newsID },
) {
  const url = `${publicService}/public/config/news/${newsID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateNews(
  { publicService },
  authenticationToken,
  { newsID, payload },
) {
  const url = `${publicService}/public/config/news/${newsID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertNews = async (
  { publicService },
  authenticationToken,
  { payload },
) => {
  const url = `${publicService}/public/config/news`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export async function setNewsOrder(
  { publicService },
  authenticationToken,
  { orderList },
) {
  const url = `${publicService}/public/config/news/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
}

export async function fetchAnnouncements(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/psas`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAnnouncement(
  { publicService },
  authenticationToken,
  { psaID },
) {
  const url = `${publicService}/public/config/psa/${psaID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteAnnouncement(
  { publicService },
  authenticationToken,
  { psaID },
) {
  const url = `${publicService}/public/config/psa/${psaID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateAnnouncement(
  { publicService },
  authenticationToken,
  { psaID, payload },
) {
  const url = `${publicService}/public/config/psa/${psaID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertAnnouncement = async (
  { publicService },
  authenticationToken,
  { payload },
) => {
  const url = `${publicService}/public/config/psas`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const setAnnouncementsOrder = async (
  { publicService },
  authenticationToken,
  { orderList },
) => {
  const url = `${publicService}/public/config/psas/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
};

export async function fetchLanguages(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Public Website&name=News Language`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSettings({ publicService }, authenticationToken) {
  const url = `${publicService}/public/config/publicsite`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSettings(
  { publicService },
  authenticationToken,
  payload,
) {
  const url = `${publicService}/public/config/publicsite`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchOnlineFormTypes(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/formtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateOnlineFormType(
  { publicService },
  authenticationToken,
  { publicUserFormTypeID, payload },
) {
  const url = `${publicService}/public/formtype/${publicUserFormTypeID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPIDRules({ publicService }, authenticationToken) {
  const url = `${publicService}/public/config/pIDRules`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAllQuickLinks(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/quicklinks`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchQuickLink(
  { publicService },
  authenticationToken,
  { quickLinkID },
) {
  const url = `${publicService}/public/config/quicklinks/${quickLinkID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteQuickLink(
  { publicService },
  authenticationToken,
  { quickLinkID },
) {
  const url = `${publicService}/public/config/quicklinks/${quickLinkID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateQuickLink(
  { publicService },
  authenticationToken,
  { quickLinkID, payload },
) {
  const url = `${publicService}/public/config/quicklinks/${quickLinkID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertQuickLink = async (
  { publicService },
  authenticationToken,
  { payload },
) => {
  const url = `${publicService}/public/config/quicklinks`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function setQuickLinkOrder(
  { publicService },
  authenticationToken,
  { orderList },
) {
  const url = `${publicService}/public/config/quicklinks/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
}

export async function fetchAllTiles({ publicService }, authenticationToken) {
  const url = `${publicService}/public/config/tiles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTile(
  { publicService },
  authenticationToken,
  { tileID },
) {
  const url = `${publicService}/public/config/tiles/${tileID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteTile(
  { publicService },
  authenticationToken,
  { tileID },
) {
  const url = `${publicService}/public/config/tiles/${tileID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateTile(
  { publicService },
  authenticationToken,
  { tileID, payload },
) {
  const url = `${publicService}/public/config/tiles/${tileID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const insertTile = async (
  { publicService },
  authenticationToken,
  { payload },
) => {
  const url = `${publicService}/public/config/tiles`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function setTileOrder(
  { publicService },
  authenticationToken,
  { orderList },
) {
  const url = `${publicService}/public/config/tiles/setorder`;
  const { body } = await put(authenticationToken, url, { orderList });
  return body;
}

export async function addAppraisalNoticeForm(
  { publicService },
  authenticationToken,
  form,
) {
  const eventFormsUrl = `${publicService}/public/config/appraisalnoticeforms`;
  const response = await fetch(eventFormsUrl, {
    headers: {
      Authorization: authenticationToken,
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(form),
  });
  return await response.json();
}

export async function deleteAppraisalNoticeForm(
  { publicService },
  authenticationToken,
  { publicApprNoticeFormConfigID },
) {
  const eventFormsUrl = `${publicService}/public/config/appraisalnoticeform/${publicApprNoticeFormConfigID}`;
  const response = await fetch(eventFormsUrl, {
    headers: {
      Authorization: authenticationToken,
    },
    method: 'DELETE',
  });
  return await response.json();
}

export async function fetchAppraisalNoticeForms(
  { publicService },
  authenticationToken,
) {
  const eventFormsUrl = `${publicService}/public/config/appraisalnoticeforms`;
  const eventForms = await fetch(eventFormsUrl, {
    headers: {
      Authorization: authenticationToken,
    },
  });
  return await eventForms.json();
}

export async function fetchAppraisalNoticeFormOptions(
  { eventService },
  authenticationToken,
) {
  const eventFormsUrl = `${eventService}/events/peventformsui?includeEventTypes=1`;
  const eventForms = await fetch(eventFormsUrl, {
    headers: {
      Authorization: authenticationToken,
    },
  });
  return await eventForms.json();
}

export async function updateAppraisalNoticeForm(
  { publicService },
  authenticationToken,
  form,
) {
  const eventFormsUrl = `${publicService}/public/config/appraisalnoticeform/${form.publicApprNoticeFormConfigID}`;
  const response = await fetch(eventFormsUrl, {
    headers: {
      Authorization: authenticationToken,
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify(form),
  });
  return await response.json();
}
